import { useState, useEffect } from 'react';
import moment from 'moment-timezone';

import { LocalSiderealTime } from "../utils/functions";

import config from "../config.json";

export function useUTCTime() {
  const [UTCTime, setUTCTime] = useState(moment.utc());

  useEffect(() => {
    const intervalId = setInterval(() => {
      setUTCTime(moment.utc());
    }, 1000 * 60 * 0.5); // Actualizar cada medio minuto  (milisegundos * segundos * medio minuto)

    return () => clearInterval(intervalId);
  }, []);

  return UTCTime;
}


export function useLocalTime() {
  const [localTime, setLocalTime] = useState(moment());

  useEffect(() => {
    const intervalId = setInterval(() => {
      setLocalTime(moment());
    }, 1000*60); // Actualizar cada minuto

    // Limpiar el intervalo cuando el componente se desmonte
    return () => clearInterval(intervalId);
  }, []); // El array vacío asegura que el efecto se ejecute solo una vez al montar y desmontar
  return localTime;
}

export function useDates() {

  const local_time = useLocalTime();
  const [lst, setLst] = useState(moment());
  const utc = useUTCTime();

  const longitude = config.location.longitude ;

  useEffect(() => {
    const updateLST = () => {
      const siderealTime = LocalSiderealTime(utc.toDate(), longitude);
      setLst(siderealTime);
    };

    updateLST(); // Inicial
    const interval = setInterval(updateLST, 1000*60); // Cada minuto

    return () => clearInterval(interval); // Limpieza
  }, [longitude]);

  let dates = {
    utc: utc.format('HH:mm'),                   // UTC in moment
    local_time: local_time.format('HH:mm'),     // Local time in moment
    lst: lst.format('HH:mm')                    // LST in moment
  };

  return dates;
}